import { Body } from '../../Layouts/Body'
import { WhiteBox } from '../../../components/WhiteBox'
import { Flex } from '@chakra-ui/layout'
import { Button } from '../../../components/Button'
import { NavLine } from '../../../components/NavLine'
import { FaPlus, FaSearch } from 'react-icons/fa'
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/input'
import { useEffect, useState } from 'react'
import { Card } from './Components/Card'
import { appApi } from '../../../services/appApi'
import { iGrupoTrilha } from '../../../interfaces'
import { ModalDelete } from '../../../components/ModalDelete'
import { ModalNovoGrupo } from './Components/ModalNovoGrupo'
import { ModalEditarGrupo } from './Components/ModalEditarGrupo'
import { useLocation, useNavigate } from 'react-router'
import { useToast } from '@chakra-ui/react'
export const TrilhaOnboard: React.FC = () => {
  const toast = useToast()
  const { search } = useLocation()
  const nav = useNavigate()
  const tipo = search.split('tipo=')[1] ?? 0

  const [BarraPesquisa, setBarraPesquisa] = useState('')
  const [Cards, setCards] = useState<iGrupoTrilha[]>([])

  const [ModalCriarIsOpen, setModalCriarIsOpen] = useState(false)
  const [ModalEditisOpen, setModalEditIsOPen] = useState(false)

  const [EditGrupo, setEditGrupo] = useState<iGrupoTrilha>({
    categoria: 0,
    cor: '',
    id: '',
    nome: '',
    padrao: true,
    tags: [],
    countEtapas: 0,
    countProcessos: 0
  })

  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [Id, setId] = useState('')

  function ListarCards(): void {
    appApi.get(`GrupoTrilha?tipo=${tipo}`)
      .then(response => { setCards(response.data) }).catch(err => console.error(err))
  }

  function CriarGrupo(cor: string, nome: string, tags: string[]): void {
    const form = {
      cor: cor,
      nome: nome,
      tags: tags
    }
    appApi.post(`GrupoTrilha?tipo=${tipo}`, form)
      .then(() => {
        toast({
          title: 'Trilha criada com sucesso!',
          status: 'success',
          duration: 5000,
          isClosable: false
        })
        ListarCards()
        setModalCriarIsOpen(false)
      })
      .catch(err => console.error(err))
  }

  function AtualizarGrupo(cor: string, nome: string, tags: string[]): void {
    const form = {
      cor: cor,
      nome: nome,
      categoria: tipo,
      tags: tags
    }
    appApi.put(`GrupoTrilha/${EditGrupo.id}`, form).then(() => {
      toast({
        title: 'Trilha atualizada com sucesso!',
        status: 'success',
        duration: 5000,
        isClosable: false
      })
      ListarCards()
      setModalEditIsOPen(false)
    }).catch(err => console.log(err))
  }

  function closeModalDelete(): void {
    setModalDeleteIsOpen(false)
    setId('')
  }

  function onOpenModalDelete(id: string): void {
    setModalDeleteIsOpen(true)
    setId(id)
  }

  function DeleteTrilha(): void {
    appApi.delete(`GrupoTrilha/${Id}`)
      .then(() => {
        toast({
          title: 'Trilha deletada com sucesso!',
          status: 'success',
          duration: 5000,
          isClosable: false
        })
        ListarCards()
        closeModalDelete()
      })
      .catch(err => console.log(err))
  }

  function onRequestEditCloseModal(): void {
    setModalEditIsOPen(false)
    setEditGrupo({
      categoria: 0,
      cor: '',
      id: '',
      nome: '',
      padrao: true,
      tags: [],
      countEtapas: 0,
      countProcessos: 0
    })
  }

  function onRequestEditOpenModal(obj: iGrupoTrilha): void {
    setModalEditIsOPen(true)
    setEditGrupo(obj)
  }

  function CopiarTrilha(id: string): void {
    appApi.post(`GrupoTrilha/Copy/${id}`)
      .then(() => {
        ListarCards()
        window.location.reload()
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    ListarCards()
  }, [search])

  return (
    <Body>
      <ModalDelete
        isOpen={ModalDeleteIsOpen}
        onConfirm={DeleteTrilha}
        onRequestClose={closeModalDelete}
        message='Realmente deseja excluir essa trilha? As trilhas de colaborador criadas a partir desta continuarão em andamento'
      />

      <ModalNovoGrupo
        isOpen={ModalCriarIsOpen}
        onCreate={CriarGrupo}
        onRequestClose={() => { setModalCriarIsOpen(false) }}
      />

      <ModalEditarGrupo
        onRequestClose={onRequestEditCloseModal}
        onUpdate={AtualizarGrupo}
        isOpen={ModalEditisOpen}
        Card={EditGrupo}
      />
      <Flex margin={'1rem 0'}>
        <Button onClick={() => nav(`/Jornada/Onboard/?tipo=${tipo}`)} VarColor='c6' size={'lg'}>Voltar</Button>
      </Flex>
      <Flex marginBottom={'1rem'}>
        <NavLine options={[{
          nome: 'Jornada',
          path: `/Jornada/Onboard/?tipo=${tipo}`
        },
        {
          nome: `${tipo === '0' ? 'Configuração de trilhas de onboarding' : tipo === '1' ? 'Configuração de trilhas de desenvolvimento' : tipo === '3' ? 'Configuração das etapas de offboarding' : ''}`
        }]} />
      </Flex>

      <Flex marginBottom={'2rem'} justifyContent={'space-between'}>
        <h1>{tipo === '0' ? 'Configuração de trilhas de onboarding' : tipo === '1' ? 'Configuração de trilhas de desenvolvimento' : tipo === '3' ? 'Configuração das etapas de offboarding' : ''}</h1>
        <Button VarColor='Azul' leftIcon={<FaPlus />} onClick={() => setModalCriarIsOpen(true)}>Adicionar nova trilha</Button>
      </Flex>
      <WhiteBox>
        <Flex marginBottom={'2rem'}>
          <InputGroup width={'25rem'}>
            <InputLeftElement
              pointerEvents='none'
              children={<FaSearch color='var(--Gray4)' />}
            />
            <Input
              borderColor={'var(--Gray4)'}
              type='text'
              placeholder='Pesquisa'
              onChange={(e) => setBarraPesquisa(e.target.value)}
            />
          </InputGroup>
        </Flex>
        <Flex gap={'2rem'} flexWrap='wrap'>
          {Cards.filter((val: iGrupoTrilha) => {
            if (BarraPesquisa === '') {
              return val
            } else if (val.nome.toLowerCase().includes(BarraPesquisa.toLowerCase())) {
              return val
            }
            return ''
          }).map((e, i) => {
            return (
              <Card
                key={i}
                trilha={e}
                onDelete={onOpenModalDelete}
                onEdit={onRequestEditOpenModal}
                onCopy={CopiarTrilha}
              />
            )
          })}
        </Flex>
      </WhiteBox>
    </Body>
  )
}
